import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import {
  Card,
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
} from 'react-md';
import qs from 'qs';

import SpeedingBadges, { Badge } from '../SpeedingBadges';
import TooltipFontIcon from '../TooltipFontIcon';
import { invokeBackendApi } from '../../libs/awsLib';

import './DriverSelection.css';

export default withRouter(injectIntl(class DriverSelection extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    history: PropTypes.object.isRequired,
    segmentsByDriver: PropTypes.array,
    dashboard: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      drivers: [],
      sortedDrivers: [],
      sortColumn: 1,
    };
  }

  componentDidMount() {
    this.loadDrivers();
  }

  drivers = () => invokeBackendApi({ path: '/drivers' })

  loadDrivers = () => {
    this.drivers()
      .then(drivers => this.setState({ isLoading: false, drivers }, () => this.sort(this.state.sortColumn)))
      .catch(e => alert(e));
  }

  handleOnclick = (driver) => {
    console.log('driver', driver);
    const { history } = this.props;
    const search = qs.stringify({ driver: driver.attr.sub });
    localStorage.currentDriverName = `${driver.attr.name} ${driver.attr.family_name}`;
    history.push({ pathname: '/calendar', search });
  }

  handleOnConstestedClick = (driver, e) => {
    e.stopPropagation();
    console.log('driver', driver);
    const { history } = this.props;
    const search = qs.stringify({ driver: driver.attr.sub });

    history.push({ pathname: '/contested', search });
  }

  handleClickColumnHeader = (columnNumber) => {
    const ascending = !this.isSorted(columnNumber);
    const newSort = ascending ? columnNumber : -columnNumber;
    this.sort(newSort);
  }

  sort = (newSort) => {
    const { drivers } = this.state;
    const displayedAttributes = ['name'];
    const comparedAttribute = displayedAttributes[Math.abs(newSort) - 1];
    const dessending = newSort < 0;
    const sortedDrivers = drivers.slice().sort((a, b) => {
      if (dessending) [a, b] = [b, a];
      return (a.attr[comparedAttribute] || '')
        .localeCompare(b.attr[comparedAttribute] || '');
    });
    this.setState({ sortedDrivers, sortColumn: newSort });
  };

  isSorted = (columnNumber) => {
    if (this.state.sortColumn === columnNumber) return true;
    else if (this.state.sortColumn === -columnNumber) return false;
    return undefined;
  };

  render() {
    const { intl, segmentsByDriver, dashboard } = this.props;
    const { sortedDrivers } = this.state;

    return (
      <Card>
        <DataTable plain className="bottom-padded">
          <TableHeader>
            <TableRow>
              <TableColumn
                sorted={this.isSorted(1)}
                onClick={() => { this.handleClickColumnHeader(1); }}
              >
                {intl.formatMessage({ id: 'driverSelection.name' })}
              </TableColumn>
              <TableColumn>{/* comment */}</TableColumn>
              <TableColumn>
                {intl.formatMessage({ id: 'driverSelection.birthdate' })}
              </TableColumn>
              <TableColumn>
                {intl.formatMessage({ id: 'driverSelection.lastConsultation' })}
              </TableColumn>
              <TableColumn
                className="md-text-center"
              >
                {intl.formatMessage({ id: 'driverSelection.disconnected' })}
              </TableColumn>
              <TableColumn
                className="md-text-center"
              >
                {intl.formatMessage({ id: 'driverSelection.constested' })}
              </TableColumn>
              <TableColumn>{intl.formatMessage({ id: 'driverSelection.speeding' })}</TableColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedDrivers.map(d => (
              <TableRow key={d.attr.sub} className="md-pointer--hover" onClick={() => this.handleOnclick(d)}>
                <TableColumn>{d.attr.name} {d.attr.family_name}</TableColumn>
                <TableColumn>
                  {d.attr['custom:comment'] &&
                  <TooltipFontIcon tooltipLabel={<div className="myTooltip">{d.attr['custom:comment']}</div>}>
                    comment
                  </TooltipFontIcon>}
                </TableColumn>
                <TableColumn>
                  {d.attr.birthdate}
                </TableColumn>
                <TableColumn>{(dashboard[d.attr.sub] || {}).lastConsultation && intl.formatDate(dashboard[d.attr.sub].lastConsultation, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                })}
                </TableColumn>
                <TableColumn className="md-text-center">
                  <Badge value={(dashboard[d.attr.sub] || {}).unplugged} notzeroClassName="disconnectedNotZero" />
                </TableColumn>
                <TableColumn className="md-text-center">
                  <Badge
                    value={(segmentsByDriver.find(a => (a[0] || {}).driverId === d.attr.sub) || []).length}
                    className="md-pointer--hover"
                    onClick={e => this.handleOnConstestedClick(d, e)}
                  />
                </TableColumn>
                <TableColumn><SpeedingBadges {...(dashboard[d.attr.sub] || {}).lastStats} /></TableColumn>
              </TableRow>
            ))}
          </TableBody>
        </DataTable>
      </Card>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/components/DriverSelection/index.js